import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { useContext } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { BrowserRouter, Redirect, Route, Switch, useHistory } from 'react-router-dom';

import Sidebar from './components/UI/Sidebar/Sidebar';
import Chat from './containers/Chat/Chat';
import Login from './containers/Login/Login';
import EditProfile from './containers/Profile/EditProfile/EditProfile';
import Profile from './containers/Profile/Profile';
import Support from './containers/Support/Support';

import { Context } from './index';

const ProtectedRoute = ({ isAllowed, ...props }) =>
  isAllowed ? <Route {...props} /> : <Redirect to="/" />;
const ProtectedSignRoute = ({ isAllowed, ...props }) => {
  const history = useHistory();
  const { pathname } = history.location;
  const isLoginPage = pathname === '/';
  return isAllowed ? <Route {...props} /> : isLoginPage && <Redirect to="/rooms" />;
};

function App() {
  const { auth } = useContext(Context);
  const [user, loading] = useAuthState(auth);
  const antIcon = <LoadingOutlined style={{ fontSize: '80px', color: '#397CF3' }} spin />;

  if (loading) {
    return (
      <div style={{ height: '100vh', display: 'flex' }}>
        <Spin indicator={antIcon} style={{ margin: 'auto' }} />
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Sidebar>
            <ProtectedSignRoute path="/" exact component={Login} isAllowed={!user} />
            <ProtectedRoute path="/profile" exact component={Profile} isAllowed={user} />
            <ProtectedRoute path="/edit-profile" exact component={EditProfile} isAllowed={user} />
            <ProtectedRoute path="/profile/:id" exact component={Profile} isAllowed={user} />
            <ProtectedRoute path="/rooms" exact component={Chat} isAllowed={user} />
            <ProtectedRoute path="/rooms/:id" exact component={Chat} isAllowed={user} />
            <ProtectedRoute path="/support" exact component={Support} isAllowed={user} />
          </Sidebar>
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
